import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import classNames from 'classnames';
import { useField, useFormikContext } from 'formik';
import RSelect, { components as reactSelectComponents } from 'react-select';
import Creatable from 'react-select/creatable';
import Async from 'react-select-async-paginate';
import get from 'lodash.get';
import isFunction from 'lodash.isfunction';
var DownChevron = reactSelectComponents.DownChevron,
    CrossIcon = reactSelectComponents.CrossIcon,
    _DropdownIndicator = reactSelectComponents.DropdownIndicator,
    _ClearIndicator = reactSelectComponents.ClearIndicator;
var components = {
  DropdownIndicator: function DropdownIndicator(props) {
    return React.createElement(_DropdownIndicator, props, React.createElement(DownChevron, null), React.createElement("span", {
      className: "sr-only"
    }, "Toggle Select Options"));
  },
  ClearIndicator: function ClearIndicator(props) {
    return React.createElement(_ClearIndicator, props, React.createElement(CrossIcon, null), React.createElement("span", {
      className: "sr-only"
    }, "Clear all selections"));
  }
};

var createOption = function createOption(label, labelKey, valueKey) {
  var _ref;

  if (labelKey === void 0) {
    labelKey = 'label';
  }

  if (valueKey === void 0) {
    valueKey = 'value';
  }

  return _ref = {}, _ref[labelKey] = label, _ref[valueKey] = label.toLowerCase().replace(/\W/g, ''), _ref;
};

var Select = function Select(_ref2) {
  var name = _ref2.name,
      validate = _ref2.validate,
      className = _ref2.className,
      options = _ref2.options,
      selectRef = _ref2.selectRef,
      styles = _ref2.styles,
      maxLength = _ref2.maxLength,
      onChangeCallback = _ref2.onChange,
      autofill = _ref2.autofill,
      creatable = _ref2.creatable,
      attributes = _objectWithoutPropertiesLoose(_ref2, ["name", "validate", "className", "options", "selectRef", "styles", "maxLength", "onChange", "autofill", "creatable"]);

  var _useField = useField({
    name: name,
    validate: validate
  }),
      _useField$ = _useField[0],
      onChange = _useField$.onChange,
      fieldValue = _useField$.value,
      field = _objectWithoutPropertiesLoose(_useField$, ["onChange", "value"]),
      _useField$2 = _useField[1],
      touched = _useField$2.touched,
      hasError = _useField$2.error;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      initialValues = _useFormikContext.initialValues;

  var _useState = useState([]),
      newOptions = _useState[0],
      setNewOptions = _useState[1];

  var getOptionLabel = function getOptionLabel(option) {
    if (option.__isNew__) {
      return option.label;
    }

    return option[get(attributes, 'labelKey', 'label')];
  };

  var getValueKey = function getValueKey(attrs) {
    if (attrs === void 0) {
      attrs = attributes;
    }

    return get(attrs, 'valueKey', 'value');
  };

  var getOptionValue = function getOptionValue(option) {
    return attributes.raw && !attributes.valueKey ? option : get(option, getValueKey(attributes), option);
  };

  var prepValue = function prepValue(value, digIfMulti) {
    if (digIfMulti === void 0) {
      digIfMulti = true;
    }

    if (attributes.isMulti && digIfMulti && Array.isArray(value)) {
      return value.map(prepValue, false);
    }

    if (attributes.raw || attributes.loadOptions) {
      return value;
    }

    var valueKey = getValueKey();
    return get(value, valueKey, value);
  };

  var findOptionFromValue = function findOptionFromValue(value, options) {
    return Array.isArray(options) && [].concat(_toConsumableArray(options), _toConsumableArray(newOptions)).filter(function (option) {
      return getOptionValue(option) === value;
    })[0];
  };

  var getViewValue = function getViewValue() {
    if (attributes.raw || attributes.loadOptions || !options) return fieldValue;

    if (attributes.isMulti && Array.isArray(fieldValue)) {
      return fieldValue.map(function (value) {
        return findOptionFromValue(value, options) || value;
      });
    }

    return findOptionFromValue(fieldValue, options) || fieldValue;
  };

  var Tag = attributes.loadOptions ? Async : RSelect;

  if (!attributes.loadOptions && creatable) {
    Tag = Creatable;
  }

  if (!attributes.inputId) {
    attributes.inputId = name;
  }

  var onChangeHandler = function onChangeHandler(newValue) {
    var _valuesToSet;

    var newVal, isOverMax, valuesToSet, shouldAutofill;
    return _regeneratorRuntime.async(function onChangeHandler$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newVal = prepValue(newValue);
            isOverMax = maxLength && attributes.isMulti && newValue && newValue.length > maxLength;

            if (!isOverMax) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return");

          case 4:
            valuesToSet = (_valuesToSet = {}, _valuesToSet[name] = true, _valuesToSet);
            _context2.next = 7;
            return _regeneratorRuntime.awrap(setFieldValue(name, newVal));

          case 7:
            shouldAutofill = autofill && !attributes.isMulti && newValue && typeof newVal === 'object';

            if (shouldAutofill) {
              Object.keys(values).filter(function (fieldName) {
                return fieldName !== name;
              }).forEach(function _callee(fieldName) {
                var rawValue, shouldAutofillField, val;
                return _regeneratorRuntime.async(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        rawValue = newValue;

                        if (!!newValue.label && !!newValue.value && typeof newValue.value === 'object') {
                          rawValue = newValue.value;
                        }

                        shouldAutofillField = false;

                        if (typeof autofill === 'object') {
                          shouldAutofillField = autofill[fieldName];
                        } else {
                          shouldAutofillField = Object.prototype.hasOwnProperty.call(rawValue, fieldName);
                        }

                        if (!shouldAutofillField) {
                          _context.next = 9;
                          break;
                        }

                        if (typeof autofill === 'object') {
                          if (isFunction(autofill[fieldName])) {
                            val = autofill[fieldName](rawValue);
                          } else if (typeof autofill[fieldName] === 'string') {
                            val = get(rawValue, "" + autofill[fieldName], initialValues[fieldName]);
                          } else {
                            val = initialValues[fieldName];
                          }
                        } else {
                          val = get(rawValue, fieldName, initialValues[fieldName]);
                        }

                        valuesToSet[fieldName] = true;
                        _context.next = 9;
                        return _regeneratorRuntime.awrap(setFieldValue(fieldName, val));

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                });
              });
            }

            if (onChangeCallback) {
              onChangeCallback(newVal);
            }

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    });
  };

  var handleCreate = function handleCreate(value) {
    var newOpt = createOption(value, get(attributes, 'labelKey', 'label'), get(attributes, 'valueKey', 'value'));
    newOptions.push(newOpt);
    setNewOptions(_toConsumableArray(newOptions));

    if (attributes.isMulti) {
      onChangeHandler(Array.isArray(fieldValue) ? fieldValue.concat(newOpt) : [newOpt]);
    } else {
      onChangeHandler(newOpt);
    }
  };

  return React.createElement(Tag, Object.assign({}, field, {
    onChange: onChangeHandler,
    ref: selectRef,
    name: name,
    classNamePrefix: "av",
    role: "listbox",
    SelectComponent: attributes.loadOptions && creatable ? Creatable : undefined,
    onCreateOption: handleCreate,
    className: classNames(className, 'av-select', touched ? 'is-touched' : 'is-untouched', hasError ? 'av-invalid' : 'av-valid', touched && hasError && 'is-invalid'),
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    closeMenuOnSelect: !attributes.isMulti,
    components: components,
    options: !attributes.loadOptions ? [].concat(_toConsumableArray(options), _toConsumableArray(newOptions)) : undefined,
    defaultOptions: true,
    styles: _objectSpread({}, styles, {
      placeholder: function placeholder(provided, state) {
        if (state.isDisabled) {
          return provided;
        }

        var showError = touched && hasError && !state.focused;
        return _objectSpread({}, provided, {
          color: showError ? '#3D3D3D' : '#666',
          maxWidth: '99%'
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread({}, provided, {
          width: '90%'
        });
      },
      singleValue: function singleValue(provided) {
        return _objectSpread({}, provided, {
          color: '#495057'
        });
      },
      control: function control(provided, state) {
        if (state.isDisabled) {
          return _objectSpread({}, provided, {
            borderRadius: '.25em',
            borderColor: '#ced4da',
            backgroundColor: '#e9ecef'
          });
        }

        var showError = touched && hasError && !state.focused;
        return _objectSpread({}, provided, {
          borderRadius: '.25em',
          backgroundColor: showError ? '#fbcbc8' : 'white',
          borderColor: showError ? '#931b1d' : 'hsl(0,0%,80%)',
          zIndex: state.focused && '3'
        });
      },
      multiValue: function multiValue(provided) {
        return _objectSpread({}, provided, {
          width: 'auto'
        });
      },
      input: function input(provided) {
        return _objectSpread({}, provided, {
          maxWidth: '99%'
        });
      },
      dropdownIndicator: function dropdownIndicator(provided, state) {
        if (state.isDisabled) {
          return provided;
        }

        var showError = touched && hasError && !state.focused;
        return _objectSpread({}, provided, {
          pointerEvents: 'none',
          color: showError ? '#931b1d' : 'hsl(0,0%,80%)'
        });
      },
      option: function option(provided) {
        return _objectSpread({}, provided, {
          color: '#000'
        });
      }
    })
  }, attributes, {
    value: getViewValue()
  }));
};

export default Select;